import { UserHelper } from '@/helpers/user.helper';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Sharing, SharingService, SharingViewStat } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { DateTimeFormatPipe } from '@/extensions/dateTimePipe';
import { NgTemplateOutlet, NgIf, NgFor } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export class ShareStatDialogData {
  share: Sharing;
}

@Component({
    selector: 'app-share-stat-dialog',
    templateUrl: './share-stat-dialog.component.html',
    styleUrls: ['./share-stat-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, NgIf, NgFor, DateTimeFormatPipe]
})
export class ShareStatDialogComponent implements OnInit, OnDestroy {
  dialogTitle = 'Statistiques du partage';

  shareStatSub = new Subscription();
  stats: SharingViewStat;
  targetUserName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ShareStatDialogData,
    private dialog: MatDialog,
    private shareService: SharingService
  ) {}

  ngOnInit(): void {
    this.shareStatSub = this.shareService.getSharingStats(this.data.share.uid).subscribe({
      next: (stats) => (this.stats = stats)
    });
    this.targetUserName = this.data.share.targetUser
      ? UserHelper.userSummmaryDisplayName(this.data.share.targetUser)
      : null;
  }

  ngOnDestroy(): void {
    this.shareStatSub.unsubscribe();
  }
}
